import { render, staticRenderFns } from "./why-ab-is-the-master-of-reverse-sweep.vue?vue&type=template&id=0650f886&scoped=true&"
var script = {}
import style0 from "./why-ab-is-the-master-of-reverse-sweep.vue?vue&type=style&index=0&id=0650f886&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0650f886",
  null
  
)

export default component.exports